import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';
import './learn.css';

// Reuse lesson styling inside the shared Guides shell.
export default function LearnSurface({ children }) {
  const { theme, colors } = useTheme();
  const palette = getCatalogPalette(theme);
  return <div className="learn-app" data-theme="light" style={{ height: 'auto', display: 'block',
    '--learn-bg': colors.solid_color_primary, '--learn-ink': colors.text_color_primary,
    '--learn-muted': colors.text_color_secondary, '--learn-surface': palette.preview,
    '--learn-border': palette.border, '--learn-control': palette.activeBorder,
    '--learn-card': palette.surface, '--learn-card-hover': palette.hover, '--learn-card-border': palette.border,
  }}>{children}</div>;
}
